import Button from 'react-bootstrap/Button'
import css from './AIDemo.module.css'

const HowTo = ({onHide,children})=>(
	<div onClick={onHide} id={css.HowTo}>
		<div onClick={e=>{e.stopPropagation()}}>
			<div className="text-right">
				<Button variant="outline-danger" onClick={onHide} size="sm">
					Close
				</Button>
			</div>
			{children}
		</div>
	</div>
)

export default HowTo